import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { Trophy, Medal } from "lucide-react";
import { eur } from "@/lib/format";
import { LiveBadge } from "@/components/LiveBadge";
import { motion } from "framer-motion";

export function LeaderboardTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const fetchRows = () => api.get("/admin/agents").then((r) => setRows(r.data)).catch(() => setRows((p) => p || []));
    fetchRows();
    const id = setInterval(fetchRows, 6000);
    return () => clearInterval(id);
  }, []);

  if (!rows) return <Skeleton className="h-64 bg-[#FFFFFF]" />;

  const medal = (i) => (i === 0 ? "#FFD700" : i === 1 ? "#C0C0C0" : i === 2 ? "#CD7F32" : null);

  return (
    <Card className="bg-[#FFFFFF] border-[#DCE7F5] overflow-hidden" data-testid="leaderboard-tab">
      <div className="p-5 border-b border-[#DCE7F5] font-display font-semibold flex items-center justify-between">
        <span className="flex items-center gap-2"><Trophy className="w-4 h-4 text-[#0B6BCB]" strokeWidth={1.5} /> Classifica globale agenti</span>
        <LiveBadge />
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-[#DCE7F5] hover:bg-transparent">
              <TableHead className="text-[#5A6B85]">#</TableHead>
              <TableHead className="text-[#5A6B85]">Agente</TableHead>
              <TableHead className="text-[#5A6B85]">Capo Area</TableHead>
              <TableHead className="text-[#5A6B85] text-right">Vendite</TableHead>
              <TableHead className="text-[#5A6B85] text-right">Premi vinti</TableHead>
              <TableHead className="text-[#5A6B85] text-right">Valore premi</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((a, i) => (
              <motion.tr
                layout
                key={a.id}
                data-testid={`leaderboard-row-${a.id}`}
                className="border-b border-[#DCE7F5] hover:bg-[#EEF4FC] transition-colors"
                transition={{ layout: { type: "spring", stiffness: 200, damping: 26 } }}
              >
                <TableCell>
                  {medal(i) ? <Medal className="w-4 h-4" style={{ color: medal(i) }} strokeWidth={2} /> : <span className="text-[#5A6B85]">{i + 1}</span>}
                </TableCell>
                <TableCell className="font-medium">{a.full_name}</TableCell>
                <TableCell className="text-[#5A6B85]">{a.manager_name || <span className="text-[#94A3B8]">—</span>}</TableCell>
                <TableCell className="text-right text-[#5A6B85]">{a.count}</TableCell>
                <TableCell className="text-right text-[#5A6B85]">{a.prizes_won}</TableCell>
                <TableCell className="text-right font-semibold text-[#0B6BCB]">{eur(a.prize_value)}</TableCell>
              </motion.tr>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-[#5A6B85] py-8">Nessun agente</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
